export class AppConstants {

    // When a new field is added, we identify the field's properties using this object
    // This can be considered more like a template for each form field
    public static NEW_CONFIG_FIELDS = {
        text: {
            type: 'input',
            input_type: 'text',
            label: 'Caption',
            name: 'inputTextField',
            placeholder: 'Enter a value',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        file: {
            type: 'file',
            label: 'Select file',
            placeholder: 'Select file',
            name: 'inputFileField',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        select: {
            type: 'select',
            label: 'Select Options',
            name: 'selectField',
            options: ['Option 1', 'Option 2'],
            placeholder: 'Select an option',
            convertToTag: false,
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        textarea: {
            type: 'textarea',
            label: 'Paragraph Caption',
            name: 'inputTextarea',
            placeholder: 'Enter a paragraph',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        password: {
            type: 'input',
            input_type: 'password',
            label: 'Password',
            name: 'inputPasswordField',
            placeholder: 'Enter password',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        date: {
            type: 'input',
            input_type: 'date',
            label: 'Date',
            name: 'inputDateField',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        url: {
            type: 'input',
            input_type: 'url',
            label: 'URL',
            name: 'inputUrlField',
            placeholder: 'Enter URL',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        tel: {
            type: 'input',
            input_type: 'tel',
            label: 'Phone',
            name: 'inputPhoneField',
            placeholder: 'Enter Phone Number',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        email: {
            type: 'input',
            input_type: 'email',
            label: 'Email',
            name: 'inputEmailField',
            placeholder: 'Enter email address',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: true
            }
        },
        number: {
            type: 'input',
            input_type: 'number',
            label: 'Number',
            name: 'inputNumberField',
            placeholder: 'Enter Number',
            editable: true,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        checkbox: {
            type: 'checkbox',
            label: 'Select Multiple Options',
            name: 'inputCheckboxField',
            choices: ['Option 1', 'Option 2'],
            editable: true,
            convertToTag: false,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        radio: {
            type: 'radio',
            label: 'Select Option',
            name: 'inputRadioField',
            options: ['Yes', 'No'],
            editable: true,
            convertToTag: false,
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            }
        },
        terms: {
            type: 'terms',
            label: 'Enter your detailed terms for this checkbox',
            name: 'inputTermsField',
            editable: true,
            labelMaxCharacters: 10000,
            labelMaxRows: 12,
            eeo: false,
            validatorInfo: {
                required: true,
                email: false
            }
        },
        infoMessage: {
            type: 'infoMessage',
            label: 'This is an informational message with <strong>HTML support</strong>',
            labelMaxCharacters: 10000,
            labelMaxRows: 12,
            name: 'displayInfoMessage',
            eeo: false,
            validatorInfo: {
                required: false,
                email: false
            },
            editable: true
        },
    };
}
